import React from "react";

const KPICardGrid = ({ children, columns }) => {
  const cols = columns || React.Children.count(children);
  const colClass =
    cols >= 4
      ? "lg:grid-cols-4"
      : cols === 3
        ? "lg:grid-cols-3"
        : "lg:grid-cols-2";

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 ${colClass} gap-3`}>
      {children}
    </div>
  );
};

export default KPICardGrid;
